export const JS_FILES = {
  APP_CONFIG: "app_config.js",
};
